export default __webpack_public_path__ + "static/media/info_grey.a3707e67.svg";